<template>
  <h1
    v-if="offlineConfirmed"
  >
    The page timed out while loading. Are you sure you're still connected to
    the Internet?
  </h1>
  <LoadingView v-else />
</template>

<script>
// import axios from "axios";
import LoadingView from './_loading.vue'

export default {
  page: {
    title: 'Page timeout',
    meta: [
      { name: 'description', content: 'The page timed out while loading.' }
    ]
  },

  components: { LoadingView },

  data() {
    return {
      offlineConfirmed: false
    }
  },

  // The page gave up loading: a held placeholder (public/index.html, an assessment report's new tab) lets go so this shows.
  created() {
    window.TC_SPLASH_FREE = true
  }
  // beforeCreate() {
  //   axios
  //     .head("/api/ping")
  //     .then(() => {
  //       window.location.reload();
  //     })
  //     .catch(() => {
  //       this.offlineConfirmed = true;
  //     });
  // }
}
</script>
